import { useEffect, useState } from 'react'
import { useSearchParams, Link } from 'react-router-dom'
import { api } from '../api.js'

export default function VerifyEmail() {
  const [params] = useSearchParams()
  const [status, setStatus] = useState('loading') // loading | success | error
  const [message, setMessage] = useState('')

  useEffect(() => {
    const token = params.get('token')
    if (!token) { setStatus('error'); setMessage('Ingen token hittades.'); return }

    api.auth.verifyEmail(token)
      .then(data => { setStatus('success'); setMessage(data.message) })
      .catch(err => { setStatus('error'); setMessage(err.message) })
  }, [params])

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 dark:bg-slate-900 p-6">
      <div className="w-full max-w-sm rounded-2xl bg-white dark:bg-slate-800 p-8 shadow-lg text-center">
        {status === 'loading' && (
          <>
            <div className="mx-auto mb-4 h-8 w-8 animate-spin rounded-full border-4 border-indigo-500 border-t-transparent" />
            <p className="text-slate-600 dark:text-slate-300">Verifierar...</p>
          </>
        )}
        {status === 'success' && (
          <>
            <p className="text-4xl mb-4">✅</p>
            <h1 className="text-xl font-bold text-slate-800 dark:text-slate-100 mb-2">E-post verifierad!</h1>
            <p className="text-slate-500 dark:text-slate-400 mb-6">{message}</p>
            <Link to="/login" className="rounded-xl bg-indigo-600 px-6 py-2.5 text-sm font-semibold text-white hover:bg-indigo-700 inline-block">
              Logga in
            </Link>
          </>
        )}
        {status === 'error' && (
          <>
            <p className="text-4xl mb-4">❌</p>
            <h1 className="text-xl font-bold text-slate-800 dark:text-slate-100 mb-2">Verifiering misslyckades</h1>
            <p className="text-slate-500 dark:text-slate-400 mb-6">{message}</p>
            <Link to="/login" className="text-sm text-indigo-600 hover:underline dark:text-indigo-400">
              Tillbaka till inloggning
            </Link>
          </>
        )}
      </div>
    </div>
  )
}
